// extracted by mini-css-extract-plugin
export var animationContainer = "_o6-0";
export var footer = "_o6-1";
export var gray = "_o6-2";
export var lineItem = "_o6-3";
export var lineItemImage = "_o6-4";
export var lineItemInfo = "_o6-5";
export var lineItemText = "_o6-6";
export var lineItems = "_o6-7";
export var modalContent = "_o6-8";
export var options = "_o6-9";
export var orderName = "_o6-a";
export var refundAmount = "_o6-b";